import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { HelmetProvider } from 'react-helmet-async';
import App from './App.tsx';
import './index.css';

// Unregister any stale service workers (Safari mobile caching culprit)
if ('serviceWorker' in navigator) {
  navigator.serviceWorker.getRegistrations().then(registrations => {
    for (const registration of registrations) {
      registration.unregister();
    }
  });
}

// Force reload when a new version is deployed (catches Safari bfcache + version drift)
const APP_VERSION = '2026-04-25-001';
const storedVersion = localStorage.getItem('app_version');
if (storedVersion && storedVersion !== APP_VERSION) {
  localStorage.setItem('app_version', APP_VERSION);
  window.location.reload();
} else {
  localStorage.setItem('app_version', APP_VERSION);
}

// Reload when Safari restores a page from the back-forward cache
window.addEventListener('pageshow', (event) => {
  if (event.persisted) {
    window.location.reload();
  }
});

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <HelmetProvider>
      <App />
    </HelmetProvider>
  </StrictMode>
);